import { TipsAndUpdates } from "@mui/icons-material";
import { Alert, Link, Stack, Typography } from "@mui/material";

export function Fifpl() {
    return (
        <Stack gap={1}>
            <Alert severity="info" icon={<TipsAndUpdates />}>
                Ce pack peut bénéfichier d'une prise en charge FIFPL jusqu'à 300€ !*
            </Alert>
            <Typography color="text.secondary" variant="body2">
                *Pour profiter de cette prise en charge FIFPL, il vous suffit de contacter notre <b>service client</b> à l'adresse suivante : <Link href="mailto:sav@learnylib.com">sav@learnylib.com</Link>.
                <br/>
                Nous vous fournirons alors tous les éléments nécessaires à transmettre au FIFPL pour votre demande de prise en charge.
                <br/>
                Cliquez sur <b>S'inscrire</b> et effectuer votre paiement dès maintenant.
            </Typography>
        </Stack>
    );
}